<template>
  <div>
    <el-form class="kewen-form" ref="form" label-width="80px">
      <el-form-item label="等级">
        <el-select filterable v-model="form.level" placeholder="等级">
          <el-option
            v-for="item in $store.getters.levels"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        &nbsp;
        <el-input v-model="form.num" placeholder="序号" style="width:80px;"></el-input>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="视频">
        <FileInput v-model="form.video" accept="video/*"></FileInput>
      </el-form-item>
      <el-form-item class="kewen-subtitle-list" label="内容">
        <KewenSentences ref="sentences" :sentences="items" :roles="roles" :kid="form.id"></KewenSentences>
      </el-form-item>
      <el-form-item label="有效">
        <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import KewenSentences from './KewenSentences'

export default {
  name: 'KewenForm',
  components: {
    FileInput: require('@/components/FileInput').default,
    KewenSentences
  },
  data () {
    return {
      showAddItem: true,
      items: [],
      form: {
        id: null,
        level: null,
        num: null,
        title: '',
        video: '',
        status: 1
      },
      roles: []
    }
  },
  methods: {
    reset (model) {
      if (typeof model === 'number') {
        this.fetchKewen(model)
      } else {
        Object.assign(this.form, {
          id: null,
          level: null,
          num: null,
          title: '',
          video: '',
          status: 1
        }, model)
        this.items = [{}]
        this.fetchRoles();
      }
    },
    fetchRoles () {
      this.$http.get(this.$urls.kewen_role_list, {
        params: {
          page: 1,
          'per-page': 100,
          'filter[level]': this.form.level,
          'filter[num]': [0, this.form.num],
        }
      }).then(res => {
        this.roles = res.data
      })
    },
    fetchKewen (id) {
      if (id && id === this.form.id) return
      return this.$http.get(this.$urls.kewen_view, {
        params: { id }
      }).then(res => {
        Object.assign(this.form, {
          id: res.data.id,
          level: res.data.level,
          num: res.data.num,
          title: res.data.title,
          video: res.data.video,
          status: res.data.status
        })
        const items = res.data.sentences || [];
        items.forEach((n, i) => {
          n.key = i;
        })
        this.items = items
        this.fetchRoles();
      })
    },
    getFormData () {
      let para = null
      return {
        id: this.form.id,
        level: this.form.level,
        num: this.form.num,
        title: this.form.title,
        status: this.form.status,
        video: this.form.video,
        sentences: this.items.filter(s => s.id || s.text).map((s, i) => {
          if (s.paragraph) {
            para = s.paragraph
          }
          return {
            id: s.id,
            kid: s.kid,
            pid: s.pid,
            rid: s.rid,
            sid: s.sid,
            time_range: s.time_range,
            paragraphName: para,
            weight: i,
            sentence: {
              id: s.sid,
              text: s.text,
              pinyin: s.pinyin,
              audio: s.audio,
              text_chivox: s.text_chivox,
              data_json: s.data_json,
            }
          }
        }).concat(this.$refs.sentences.deletedSentences.map(s => {
          return {
            id: s.id,
            kid: s.kid,
            pid: s.pid,
            rid: s.rid,
            sid: s.sid,
            deleted: 1
          }
        }))
      }
    },
    submit () {
      var params = this.getFormData()
      if (this.form.id) {
        delete params.id
        return this.$http.put(this.$urls.kewen_update, params, {
          params: { id: this.form.id }
        })
      } else {
        return this.$http.post(this.$urls.kewen_create, params).then(data => {
          this.form.id = data.id
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .kw-timeline{
    max-width: 270px;
  }
  .kewen-subtitle{
    > div + div {
      margin-top: 3px;
    }
    +.kewen-subtitle{
      margin-top: 10px;
    }
  }
  .pinyin-preview{
    margin-left: 80px;
    margin-top: -10px;
    border-top: 1px solid #ddd;
    padding-top: 15px;
  }
</style>
